<template>
  <div>
    <p>Количество туб 600мл</p>

    <div class="calculator-output-values">
      <h5>Результаты расчета</h5>
      <table>
        <tbody>
          <tr>
            <td>Толщина стены</td>
            <td>110 мм</td>
            <td>220 мм</td>
            <td>330 мм</td>
            <td>440 мм</td>
          </tr>
          <tr>
            <td colspan="5">Длина стены</td>
          </tr>
          <tr>
            <td>10 м</td>
            <td class="calc-result-value-container">1.5</td>
            <td class="calc-result-value-container">3</td>
            <td class="calc-result-value-container">5.1</td>
            <td class="calc-result-value-container">7</td>
          </tr>
          <tr>
            <td>20 м</td>
            <td class="calc-result-value-container">3</td>
            <td class="calc-result-value-container">6</td>
            <td class="calc-result-value-container">10.2</td>
            <td class="calc-result-value-container">13</td>
          </tr>
          <tr>
            <td>30 м</td>
            <td class="calc-result-value-container">4.6</td>
            <td class="calc-result-value-container">9</td>
            <td class="calc-result-value-container">15.3</td>
            <td class="calc-result-value-container">21</td>
          </tr>
          <tr>
            <td>40 м</td>
            <td class="calc-result-value-container">6.1</td>
            <td class="calc-result-value-container">12</td>
            <td class="calc-result-value-container">20.4</td>
            <td class="calc-result-value-container">28</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      area: 1,
    };
  },
  props: {
    multiplier1: {
      type: Number,
      default: 0,
    },
    multiplier2: {
      type: Number,
      default: 0,
    },
    kit: Boolean,
  },
  computed: {
    readyWeight() {
      return (this.area * this.multiplier1).toFixed(1);
    },
    dryWeight() {
      return (this.area * this.multiplier2).toFixed(1);
    },
    kitCount() {
      return Math.ceil(this.readyWeight / 25);
    },
    packCount() {
      return Math.ceil(this.dryWeight / 20);
    },
  },
};
</script>

<style lang="scss" scoped></style>
